"use client";

import React from "react";
import { Loader as Loader2, Send, CircleCheck as CheckCircle2, CircleAlert as AlertCircle } from 'lucide-react';
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
function JobSeekerForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-8 text-center space-y-4 animate-in fade-in duration-500">
        <div className="size-12 rounded-lg bg-green-100 dark:bg-green-900/30 flex items-center justify-center mb-2">
          <CheckCircle2 className="size-6 text-green-600 dark:text-green-400" />
        </div>
        <h3 className="text-xl font-default font-semibold text-foreground">Application Received</h3>
        <p className="text-muted-foreground font-sans max-w-sm">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-6">
          Submit Another Inquiry
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-4">
        <FormField control={control} name="name" rules={{
        required: "Full name is required",
        minLength: {
          value: 2,
          message: "Name must be at least 2 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-sans">Full Name</FormLabel>
              <FormControl>
                <Input {...field} className="font-sans" />
              </FormControl>
              <FormMessage className="font-sans" />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-sans">Email Address</FormLabel>
              <FormControl>
                <Input type="email" {...field} className="font-sans" />
              </FormControl>
              <FormMessage className="font-sans" />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "Phone number is required",
        minLength: {
          value: 10,
          message: "Please enter a valid phone number"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-sans">Phone Number</FormLabel>
              <FormControl>
                <Input type="tel" {...field} className="font-sans" />
              </FormControl>
              <FormMessage className="font-sans" />
            </FormItem>} />
      </div>

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg flex items-start gap-3">
          <AlertCircle className="size-5 text-destructive shrink-0 mt-0.5" />
          <p className="text-sm text-destructive font-sans">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full font-sans h-11 text-base">
        {isSubmitting ? <>
            <Loader2 className="animate-spin mr-2 size-5" />
            Submitting...
          </> : <>
            <Send className="mr-2 size-5" />
            Submit Inquiry
          </>}
      </Button>
    </Form>;
}
export default function CareworkersContactForm() {
  return <section id="careworkers-contact-form" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6 max-w-xl">
        <Card className="shadow-lg border-border/50">
          <CardHeader className="text-center pb-8">
            <CardTitle className="text-3xl md:text-4xl font-default font-bold text-foreground mb-3">
              Connect with Caregiving Jobs
            </CardTitle>
            <CardDescription className="text-base md:text-lg font-sans text-muted-foreground">
              Submit your details below and our recruitment team will be in touch with you shortly to discuss available opportunities.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <FormProvider formId="careworker-inquiry-form" sectionName="Careworkers Contact Form" defaultValues={{
            name: "",
            email: "",
            phone: ""
          }} submitText="Submit Inquiry" successMessage="Thank you for your interest! Our recruitment team will contact you within 24-48 hours.">
              <JobSeekerForm />
            </FormProvider>
          </CardContent>
        </Card>
      </div>
    </section>;
}